var React = require('react');

function LinkdeinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.12498 13.9854V4.6416H0.218733V13.9854H3.12498ZM1.65623 3.3916C2.59373 3.3916 3.34373 2.61035 3.34373 1.67285C3.34373 0.766602 2.59373 0.0166016 1.65623 0.0166016C0.749983 0.0166016 -1.66893e-05 0.766602 -1.66893e-05 1.67285C-1.66893e-05 2.61035 0.749983 3.3916 1.65623 3.3916ZM13.9687 13.9854H14V8.86035C14 6.36035 13.4375 4.42285 10.5 4.42285C9.09373 4.42285 8.15623 5.2041 7.74998 5.92285H7.71873V4.6416H4.93748V13.9854H7.84373V9.36035C7.84373 8.1416 8.06248 6.98535 9.56248 6.98535C11.0625 6.98535 11.0937 8.36035 11.0937 9.4541V13.9854H13.9687Z"}));
}

LinkdeinInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = LinkdeinInline;

LinkdeinInline.default = LinkdeinInline;
